var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 12,
    viewBox: "0 0 48 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761719 2C0.761719 0.89543 1.65715 0 2.76172 0H10.7617C11.8663 0 12.7617 0.89543 12.7617 2V10C12.7617 11.1046 11.8663 12 10.7617 12H2.76172C1.65715 12 0.761719 11.1046 0.761719 10V2Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96191 6.35718L5.81347 8.20825L9.72265 4.29907",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 30,
    height: 8,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox2A);
export default __webpack_public_path__ + "static/media/Checkbox2A.500710238d43d78ce38beeb363b8f7e3.svg";
export { ForwardRef as ReactComponent };